/*
 * Avalanda-Shops (Vitocare + Aquanexo) — voraussichtlicher Liefertermin unter dem Preis.
 * Eine Quelle für beide Impact-Themes: workspace/shopify-themes/shared/delivery-estimate.js
 * → als assets/delivery-estimate.js in jedes Theme pushen (Custom-Asset, nicht Teil von Original-Impact).
 *
 * Füllt jedes Element mit [data-delivery-estimate] (Platzhalter im Locale-String
 * product.general.shipping_policy_html) mit einem Text wie
 *   "Lieferung voraussichtlich Mi, 09.09. – Do, 10.09. (Bestellung bis 13:30 Uhr)"
 *
 * Regeln (Christoph, 07.09.2026):
 *   - Cutoff 13:30 Uhr Europe/Berlin, Bestellung bis dahin geht taggleich an DHL
 *   - Versand nur Mo–Fr, nicht an bundesweiten + sächsischen Feiertagen, nicht am 24.12. + 31.12.
 *   - Bewegliche Feiertage werden aus dem Osterdatum berechnet → keine jährliche Pflege nötig
 *   - DHL-Laufzeit 1–2 Tage, Zustellung Mo–Sa, nicht an bundesweiten Feiertagen
 * Impact rendert den Preis-Block bei Variantenwechsel neu → MutationObserver füllt nach.
 */
(function () {
  'use strict';

  var CUTOFF_MIN = 13 * 60 + 30;          // 13:30
  var TRANSIT_MIN = 1, TRANSIT_MAX = 2;   // DHL-Werktage
  var WD = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

  // Datum als UTC-Mittag halten → keine DST-Sprünge bei Tagesarithmetik
  function mk(y, m, d) { return new Date(Date.UTC(y, m - 1, d, 12)); }
  function add(dt, n) { return new Date(dt.getTime() + n * 864e5); }
  function key(dt) { return dt.getUTCFullYear() + '-' + (dt.getUTCMonth() + 1) + '-' + dt.getUTCDate(); }
  function dow(dt) { return dt.getUTCDay(); }

  // Ostersonntag (Anonymous Gregorian algorithm)
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
        f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
        i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7,
        m = Math.floor((a + 11 * h + 22 * l) / 451), mo = Math.floor((h + l - 7 * m + 114) / 31),
        da = ((h + l - 7 * m + 114) % 31) + 1;
    return mk(y, mo, da);
  }

  var cache = {};
  // { national: Set<key>, saxony: Set<key> } je Jahr
  function holidays(y) {
    if (cache[y]) return cache[y];
    var E = easter(y), nat = {}, sax = {};
    [mk(y, 1, 1), add(E, -2), add(E, 1), mk(y, 5, 1), add(E, 39), add(E, 50),
     mk(y, 10, 3), mk(y, 12, 25), mk(y, 12, 26)].forEach(function (d) { nat[key(d)] = 1; });
    // Sachsen: Reformationstag + Buß- und Bettag (Mittwoch vor dem 23.11.)
    sax[key(mk(y, 10, 31))] = 1;
    var bb = mk(y, 11, 22); while (dow(bb) !== 3) bb = add(bb, -1);
    sax[key(bb)] = 1;
    // Betriebsruhe Lager: Heiligabend + Silvester (kein Versand, DHL stellt zu)
    var closed = {}; closed[key(mk(y, 12, 24))] = 1; closed[key(mk(y, 12, 31))] = 1;
    return (cache[y] = { nat: nat, sax: sax, closed: closed });
  }
  function isNational(dt) { return !!holidays(dt.getUTCFullYear()).nat[key(dt)]; }
  function isSaxony(dt) { return !!holidays(dt.getUTCFullYear()).sax[key(dt)]; }
  function isClosed(dt) { return !!holidays(dt.getUTCFullYear()).closed[key(dt)]; }

  function isShipDay(dt) { var w = dow(dt); return w >= 1 && w <= 5 && !isNational(dt) && !isSaxony(dt) && !isClosed(dt); }
  function isDeliveryDay(dt) { var w = dow(dt); return w >= 1 && w <= 6 && !isNational(dt); }
  function nextDay(dt, pred, inclusive) { var d = inclusive ? dt : add(dt, 1); while (!pred(d)) d = add(d, 1); return d; }

  // Jetzt in Berlin-Zeit → { today: Date(UTC-Mittag), minutes: Minuten seit Mitternacht }
  function berlinNow(now) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin', year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', hour12: false
    }).formatToParts(now || new Date());
    var p = {}; parts.forEach(function (x) { p[x.type] = x.value; });
    return { today: mk(+p.year, +p.month, +p.day), minutes: (+p.hour % 24) * 60 + (+p.minute) };
  }

  // Kern (rein, testbar): {today, minutes} → {ship, first, last, sameDay}
  function compute(state) {
    var sameDay = isShipDay(state.today) && state.minutes < CUTOFF_MIN;
    var ship = sameDay ? state.today : nextDay(state.today, isShipDay, false);
    var first = ship, i;
    for (i = 0; i < TRANSIT_MIN; i++) first = nextDay(first, isDeliveryDay, false);
    var last = ship;
    for (i = 0; i < TRANSIT_MAX; i++) last = nextDay(last, isDeliveryDay, false);
    return { ship: ship, first: first, last: last, sameDay: sameDay };
  }

  function fmt(dt) {
    var d = dt.getUTCDate(), m = dt.getUTCMonth() + 1;
    return WD[dow(dt)] + ', ' + (d < 10 ? '0' : '') + d + '.' + (m < 10 ? '0' : '') + m + '.';
  }
  function text(r) {
    var s = 'Lieferung voraussichtlich ' + fmt(r.first) + ' – ' + fmt(r.last);
    if (r.sameDay) s += ' (Bestellung bis 13:30 Uhr)';
    return s;
  }

  function fill() {
    var els = document.querySelectorAll('[data-delivery-estimate]:not([data-delivery-filled])');
    if (!els.length) return;
    var r = compute(berlinNow());
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = text(r);
      els[i].setAttribute('data-delivery-filled', '1');
      els[i].hidden = false;
    }
  }

  // Export für Tests (Node) / Debug in der Konsole
  var api = { compute: compute, text: text, fmt: fmt, holidays: holidays, mk: mk, berlinNow: berlinNow };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  window.DeliveryEstimate = api;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill); else fill();
  var pending = false;
  new MutationObserver(function () {
    if (pending) return; pending = true;
    requestAnimationFrame(function () { pending = false; fill(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  // Nach Cutoff im offenen Tab neu berechnen (alle 60 s, nur wenn sich der Text ändern würde)
  setInterval(function () {
    var els = document.querySelectorAll('[data-delivery-estimate][data-delivery-filled]');
    if (!els.length) return;
    var t = text(compute(berlinNow()));
    for (var i = 0; i < els.length; i++) if (els[i].textContent !== t) els[i].textContent = t;
  }, 60000);
})();
